import { render, staticRenderFns } from "./CreateAnnouncementForm.vue?vue&type=template&id=0ec78ccc&"
import script from "./CreateAnnouncementForm.vue?vue&type=script&lang=js&"
export * from "./CreateAnnouncementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports